import React, {
  useState,
  useEffect,
  useContext,
  useMemo,
  useCallback,
} from "react";

import {
  Grid,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Avatar,
  FormControlLabel,
  Switch,
  Card,
  CardActionArea,
  CardContent,
  Typography,
  Stepper,
  Step,
  StepLabel,
  StepConnector,
} from "@material-ui/core";

import {
  AccountCircle,
  MonetizationOn,
  ListAlt,
  PeopleAlt,
  Money,
  CheckCircle,
  ArrowForward,
  ArrowBack,
  FlightLand,
  Queue,
} from "@material-ui/icons";

import {
  WizardVenda,
  Body,
  FontButton,
  WizardFinancial,
  CardFinancial,
  WizardFooter,
  SubtitleContainer,
  ColorExample,
  Subtitle,
} from "../styles/Emissao";

import Chip from "../../../../components/basics/Chip";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import TableDefault from "../../../../components/grid/TableDefault";
import TextField from "../../../../components/basics/TextFieldErp";

import { EmissaoContext } from "../contexts/EmissaoContext";
import { QueryParamsContext } from "../../../../context/QueryParamsContext";
import Btn from "../../../../components/buttons/Btn";

import useWizardEmissaoController from "../controllers/WizardEmissaoController";
import BigDataTable from "../../../../components/tables/BigDataTable";

import moment from "moment";
import "moment/locale/pt-br";

import { InfoRounded } from "@material-ui/icons";
import Tooltip from "@material-ui/core/Tooltip";

let typingTimer = null;
const WizardEmissaoVenda = ({
  setOpenWizardVenda,
  setOpenModal,
  demandOptions = {},
}) => {
  const {
    nfeMontageType,
    loading,
    setTypeMontage,
    firstSearch,
    setFirstSearch,
  } = useContext(EmissaoContext);
  const { queryParams } = useContext(QueryParamsContext);
  const [finalConsumer, setFinalConsumer] = useState(false);

  const {
    setNfeByDemand,
    selectedReceiver,
    setSelectedReceiver,
    selectedDemands,
    setSelectedDemands,
    selectedItensDemand,
    setSelectedItensDemand,
    dataRowsDemands,
    dataRowsClients,
    dataRowsProducts,
    verifyFinancialIssue,
    calcTotalItens,
    handleNextStandard,
    handleBackStandard,
    columnsClienteSearch,
    columnsPedidoSearch,
    columnsItensSearch,
    productsWithoutTax,
    handleSearchDemandByClient,
    handleSearchClient,

    // Importações relacionadas a DI
    columnsAdditions,
    columnsDITable,
    selectedDI,
    setSelectedDI,
    handleNextDI,
    selectedAdditions,
    setSelectedAdditions,
    handleBackDI,
  } = useWizardEmissaoController();

  const [activeStep, setActiveStep] = useState(0);
  const [pageProp, setPageProp] = useState(0);
  const [detachProductsWithoutTax, setDetachProductsWithoutTax] =
    useState(true);

  const [filterClient, setFilterClient] = useState("");
  const [orderNumber, setOrderNumber] = useState("");
  const [getUsedDemands, setGetUsedDemands] = useState(false);

  const [getUsedDi, setGetUsedDi] = useState(false);
  const [queryOrWhereDi, setQueryOrWhereDi] = useState("");
  const [filterDi, setFilterDi] = useState("");

  const [clientSalesStartDate, setClientSalesStartDate] = useState(
    moment().subtract(3, "month").format("YYYY-MM-DD")
  );
  const [clientSalesFinalDate, setClientSalesFinalDate] = useState(
    moment().format("YYYY-MM-DD")
  );

  const montageTypeOptions = {
    isMontageByDevolution: demandOptions.tipo[0] === "D",
    steps: demandOptions.steps || [],
  };

  const montageFunctions = {
    standard: {
      handleNext: () =>
        handleNextStandard(
          demandOptions,
          {
            setPageProp,
            setActiveStep,
            activeStep,
          },
          finalConsumer
        ),
      handleBack: () => handleBackStandard({ setPageProp, setActiveStep }),
    },
    di: {
      handleNext: () =>
        handleNextDI({
          setPageProp,
          setActiveStep,
          activeStep,
          setOpenModal,
          setOpenWizardVenda,
        }),
      handleBack: () => handleBackDI({ setPageProp, setActiveStep }),
    },
  };

  const handleOrderNumber = useCallback(
    (prop) => {
      setOrderNumber((prop.target.value || "").replace(/[^0-9]+/g, ""));
    },
    [setOrderNumber]
  );

  useEffect(() => {
    if (selectedReceiver.length && activeStep === 1) {
      clearTimeout(typingTimer);
      typingTimer = setTimeout(() => {
        handleSearchDemandByClient({
          idClient: selectedReceiver[0].id,
          usedSales: getUsedDemands,
          clientSalesStartDate: clientSalesStartDate,
          clientSalesFinalDate: clientSalesFinalDate,
        });
      }, 800);
    }
  }, [
    selectedReceiver,
    getUsedDemands,
    clientSalesStartDate,
    clientSalesFinalDate,
    handleSearchDemandByClient,
    activeStep,
  ]);

  useEffect(() => {
    if (activeStep === 0) {
      clearTimeout(typingTimer);
      typingTimer = setTimeout(async () => {
        handleSearchClient(
          filterClient,
          !getUsedDemands,
          demandOptions?.tipo[0],
          clientSalesStartDate,
          clientSalesFinalDate
        );
      }, 800);
    }
  }, [
    activeStep,
    clientSalesFinalDate,
    clientSalesStartDate,
    demandOptions?.tipo,
    filterClient,
    getUsedDemands,
    handleSearchClient,
  ]);

  useEffect(() => {
    clearTimeout(typingTimer);
    typingTimer = setTimeout(async () => {
      const paramsOrWhere = {
        razaoFornecedor: `${filterDi}`,
        numerodi: `${filterDi}`,
      };

      if (JSON.stringify(paramsOrWhere) !== JSON.stringify(queryOrWhereDi)) {
        let stringOrWhere = "";
        Object.keys(paramsOrWhere).forEach((key) => {
          stringOrWhere += `&orwhere[${key}]=${paramsOrWhere[key]}`;
        });
        setQueryOrWhereDi(stringOrWhere);
      }
    }, 1200);
  }, [filterDi, queryOrWhereDi]);

  useEffect(() => {
    setTypeMontage(demandOptions.tipo[0]);
  }, [demandOptions.tipo, setTypeMontage]);

  useEffect(() => {
    setFilterClient(
      finalConsumer && activeStep === 0 ? "VENDA CONSUMIDOR" : ""
    );
  }, [finalConsumer, setFilterClient, activeStep]);

  useEffect(() => {
    if (
      nfeMontageType === "A" &&
      selectedReceiver.length &&
      selectedDemands.length &&
      selectedItensDemand.length
    ) {
      setNfeByDemand(
        setOpenModal,
        setOpenWizardVenda,
        montageTypeOptions.isMontageByDevolution
      );
    }
  }, [
    nfeMontageType,
    setOpenWizardVenda,
    montageTypeOptions.isMontageByDevolution,
    selectedDemands.length,
    selectedItensDemand.length,
    selectedReceiver.length,
    setNfeByDemand,
    setOpenModal,
  ]);

  const getProductsWithoutTax = useMemo(() => {
    return detachProductsWithoutTax
      ? dataRowsProducts.filter((product) =>
          productsWithoutTax()
            .map((product) => product.id)
            .includes(product.id)
        )
      : null;
  }, [dataRowsProducts, detachProductsWithoutTax, productsWithoutTax]);

  const productsWithoutDetach = useMemo(() => {
    return getProductsWithoutTax
      ? [...dataRowsProducts].sort((a, b) => {
          if (
            !getProductsWithoutTax.includes(b) &&
            getProductsWithoutTax.includes(a)
          ) {
            return -1;
          }
          if (
            getProductsWithoutTax.includes(b) &&
            !getProductsWithoutTax.includes(a)
          ) {
            return 1;
          }
          return 0;
        })
      : dataRowsProducts;
  }, [dataRowsProducts, getProductsWithoutTax]);

  //VERIFICAR
  const ColorlibConnector = withStyles({
    alternativeLabel: {
      top: 22,
    },
    active: {
      "& $line": {
        backgroundImage:
          "linear-gradient( 136deg, rgb(12, 45, 106) 0%, rgb(214, 229, 255) 50%)",
      },
    },
    completed: {
      "& $line": {
        backgroundImage:
          "linear-gradient( 136deg, rgb(12, 45, 106) 0%, rgb(214, 229, 255) 50%)",
      },
    },
    line: {
      height: 3,
      border: 0,
      backgroundColor: "#eaeaf0",
      borderRadius: 1,
    },
  })(StepConnector);

  const useColorlibStepIconStyles = makeStyles({
    root: {
      backgroundColor: "#ccc",
      zIndex: 1,
      color: "#fff",
      width: 50,
      height: 50,
      display: "flex",
      borderRadius: "50%",
      justifyContent: "center",
      alignItems: "center",
    },
    active: {
      backgroundImage:
        "linear-gradient( 136deg, rgb(12, 45, 106) 0%, rgb(214, 229, 255) 50%, rgb(188, 220, 207) 100%)",
      boxShadow: "0 4px 10px 0 rgba(0,0,0,.25)",
    },
    completed: {
      backgroundImage:
        "linear-gradient( 136deg, rgb(12, 45, 106) 0%, rgb(214, 229, 255) 50%, rgb(188, 220, 207) 100%)",
    },
  });

  useEffect(() => {
    if (finalConsumer && montageTypeOptions.steps[3] === "Financeiro") {
      montageTypeOptions.steps[3] = "Seleção de Novo Cliente";
      montageTypeOptions.steps[4] = "Financeiro";
    } else {
      montageTypeOptions.steps[3] = "Financeiro";
      delete montageTypeOptions.steps[4];
    }
  }, [finalConsumer, montageTypeOptions.steps]);

  function ColorlibStepIcon(props) {
    const classes = useColorlibStepIconStyles();
    const { active, completed } = props;

    const icons = {
      1: <PeopleAlt />,
      2: <MonetizationOn />,
      3: <ListAlt />,
      4: <Money />,
    };

    if (finalConsumer) {
      icons[5] = <Money />;
      icons[4] = <PeopleAlt />;
    }

    return (
      <div
        className={clsx(classes.root, {
          [classes.active]: active,
          [classes.completed]: completed,
        })}
      >
        {icons[String(props.icon)]}
      </div>
    );
  }

  const usualBody = () => <>{getStepContentStandard(activeStep)}</>;

  const diBody = () => {
    return <>{getStepContentDI(activeStep)}</>;
  };

  function automaticMontageBody(body) {
    switch (body) {
      case "standard":
        if (firstSearch) {
          handleSearchClient(
            filterClient,
            !getUsedDemands,
            demandOptions?.tipo[0],
            clientSalesStartDate,
            clientSalesFinalDate
          );
          setFirstSearch(false);
        }
        return usualBody();

      case "di":
        return diBody();

      default:
        console.error("nenhum corpo selecionado");
    }
  }

  // Retorno do corpo principal da montagem automática.
  // Stepper, botões de próximo, voltar e finalizar,
  // o corpo mudo de acordo com o tipo da montagem automática
  // passando o atributo "body" no segundo parâmetro da função
  // 'handleOpenClose', no arquivo 'ModalEmissaoMontAutomatica'.
  return (
    <>
      <Stepper
        alternativeLabel
        activeStep={activeStep}
        connector={<ColorlibConnector />}
      >
        {montageTypeOptions.steps.map((label) => (
          <Step key={label}>
            <StepLabel StepIconComponent={ColorlibStepIcon}>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
      <WizardVenda>
        <>{automaticMontageBody(demandOptions.body || "standard")}</>
      </WizardVenda>
      <FontButton>
        <Grid container spacing={1}>
          <Grid item sm={activeStep !== 4 ? 8 : 10}></Grid>
          <Grid item sm>
            <Btn
              startIcon={<ArrowBack />}
              disabled={activeStep === 0}
              onClick={
                montageFunctions[demandOptions.body || "standard"].handleBack
              }
              label="voltar"
              full="true"
            />
          </Grid>
          {activeStep !== 4 && (
            <Grid item sm>
              <Btn
                full="true"
                onClick={
                  montageFunctions[demandOptions.body || "standard"].handleNext
                }
                endIcon={
                  activeStep === montageTypeOptions.steps.length - 1 ? (
                    <CheckCircle />
                  ) : (
                    <ArrowForward />
                  )
                }
                label={
                  activeStep === montageTypeOptions.steps.length - 1
                    ? "Finalizar"
                    : "Próximo"
                }
              />
            </Grid>
          )}
        </Grid>
      </FontButton>
    </>
  );

  // Retorna as tabelas de busca do tipo padrão de
  // montagem automática.
  function getStepTableStandard(step) {
    switch (step) {
      case 0:
      case finalConsumer ? 3 : "":
        return (
          <>
            <Grid container spacing={2}>
              {step === 0 && (
                <>
                  <Grid item xs={2}>
                    <FormControlLabel
                      label="Consumidor final"
                      value="end"
                      control={
                        <Switch
                          checked={finalConsumer}
                          onChange={() =>
                            setFinalConsumer((current) => !current)
                          }
                          color="primary"
                        />
                      }
                    />
                  </Grid>

                  <Grid item xs={3}>
                    <FormControlLabel
                      label={`Mostrar ${
                        demandOptions?.tipo[0] === "V" ? "vendas" : "devoluções"
                      } já utilizadas`}
                      value="end"
                      control={
                        <Switch
                          checked={getUsedDemands}
                          onChange={() =>
                            setGetUsedDemands((current) => !current)
                          }
                          color="primary"
                        />
                      }
                    />
                  </Grid>

                  {getUsedDemands && (
                    <>
                      <Grid item xs={3}>
                        <TextField
                          label="Data Inicial"
                          type="date"
                          size="small"
                          value={clientSalesStartDate}
                          setValue={setClientSalesStartDate}
                        />
                      </Grid>
                      <Grid item xs={3}>
                        <TextField
                          label="Data Final"
                          type="date"
                          size="small"
                          value={clientSalesFinalDate}
                          setValue={setClientSalesFinalDate}
                        />
                      </Grid>
                      <Grid item>
                        <Tooltip
                          title={
                            <Typography variant="subtitle2">
                              Período de busca limitado à 90 dias (3 meses).
                            </Typography>
                          }
                        >
                          <InfoRounded style={{ marginTop: "15px" }} />
                        </Tooltip>
                      </Grid>
                    </>
                  )}
                </>
              )}
              <Grid item xs={12}>
                <TextField
                  label="Busque Por Qualquer Coluna Presente na Tabela"
                  value={filterClient}
                  setValue={setFilterClient}
                  variant="filled"
                  disabled={finalConsumer && activeStep === 0}
                />
              </Grid>
            </Grid>
            <TableDefault
              stickyHeader
              loading={loading}
              values={
                !finalConsumer || activeStep === 3
                  ? dataRowsClients.filter((row) => row.id !== 1)
                  : dataRowsClients
              }
              columns={columnsClienteSearch}
              maxHeight="50vh"
              rowsPerPage={10}
              selectable={true}
              multiSelect={false}
              selected={selectedReceiver}
              setSelected={setSelectedReceiver}
              tableTitle={""}
            />
          </>
        );

      case 1:
        return (
          <>
            <Grid container spacing={2} alignItems="center">
              {!montageTypeOptions.isMontageByDevolution && (
                <Grid item xs={5}>
                  <FormControlLabel
                    control={
                      <Switch
                        disabled={loading}
                        checked={getUsedDemands}
                        onChange={() =>
                          setGetUsedDemands((current) => !current)
                        }
                      />
                    }
                    label="Mostrar vendas já utilizadas"
                  />
                </Grid>
              )}
              <Grid item xs={7}>
                <FormControlLabel
                  label="Destacar produtos sem tributação para o CFOP principal"
                  value="end"
                  control={
                    <Switch
                      checked={detachProductsWithoutTax}
                      onChange={() => {
                        setDetachProductsWithoutTax((current) => !current);
                      }}
                      color="primary"
                    />
                  }
                />
              </Grid>
            </Grid>
            <Grid container spacing={2} alignItems="center">
              {getUsedDemands && (
                <>
                  <Grid item xs={3}>
                    <TextField
                      label="Data Inicial"
                      type="date"
                      size="small"
                      value={clientSalesStartDate}
                      setValue={setClientSalesStartDate}
                    />
                  </Grid>
                  <Grid item xs={3}>
                    <TextField
                      label="Data Final"
                      type="date"
                      size="small"
                      value={clientSalesFinalDate}
                      setValue={setClientSalesFinalDate}
                    />
                  </Grid>
                  <Grid item xs={1}>
                    <Tooltip
                      title={
                        <Typography variant="subtitle2">
                          Período de busca limitado à 90 dias (3 meses).
                        </Typography>
                      }
                    >
                      <InfoRounded style={{ marginTop: "15px" }} />
                    </Tooltip>
                  </Grid>
                  <Grid item xs={5}>
                    <SubtitleContainer>
                      <ColorExample />
                      <Subtitle>Vendas já utilizadas</Subtitle>
                    </SubtitleContainer>
                  </Grid>
                </>
              )}
              <Grid item xs={12}>
                <TextField
                  label="Busca por Nro Venda"
                  value={orderNumber}
                  onChange={handleOrderNumber}
                  maxLength={10}
                  variant="filled"
                />
              </Grid>
            </Grid>
            <TableDefault
              stickyHeader
              columns={columnsPedidoSearch}
              loading={loading}
              values={
                orderNumber
                  ? dataRowsDemands.filter((row) =>
                      row.numvenda.match(orderNumber)
                    )
                  : dataRowsDemands
              }
              selectable={true}
              multiSelect={true}
              selected={selectedDemands}
              setSelected={setSelectedDemands}
              maxHeight="50vh"
              tableTitle={""}
              sortBy="numvenda"
              orderSort="desc"
            />
          </>
        );
      case 2:
        return (
          <>
            <Grid item xs={12}>
              <FormControlLabel
                label="Destacar produtos sem tributação para o CFOP principal"
                value="end"
                control={
                  <Switch
                    checked={detachProductsWithoutTax}
                    onChange={() => {
                      setDetachProductsWithoutTax((current) => !current);
                    }}
                    color="primary"
                  />
                }
              />
            </Grid>
            <TableDefault
              stickyHeader
              columns={columnsItensSearch}
              loading={loading}
              values={productsWithoutDetach}
              selectable={true}
              multiSelect={true}
              selected={selectedItensDemand}
              setSelected={setSelectedItensDemand}
              selectedByRow={false}
              maxHeight="50vh"
              tableTitle={""}
              rowId="key"
              pageProp={pageProp}
              setPageProp={setPageProp}
              allChecked
            />
          </>
        );

      case finalConsumer ? 4 : 3:
        return (
          <WizardFinancial>
            <Grid container spacing={4} justifyContent="center">
              <Grid item sm={8}>
                <Chip label="Deseja o Financeiro da Nota ou Manter o Financeiro da Venda?" />
              </Grid>
              <Grid container justifyContent="center" spacing={2}>
                <Grid item sm={4}>
                  <Card>
                    <CardFinancial>
                      <Money />
                    </CardFinancial>
                    <CardActionArea>
                      <CardContent
                        onClick={() => {
                          verifyFinancialIssue(true);
                        }}
                      >
                        <Typography gutterBottom variant="h5" component="h2">
                          Financeiro Da Nota
                        </Typography>
                        <Typography
                          variant="body2"
                          color="textSecondary"
                          component="p"
                        >
                          O Contas a Receber do Pedido será atualizado de acordo
                          com as informações presentes na aba de Condição de
                          Pagamento.
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>
                <Tooltip
                  title={
                    selectedItensDemand.length <
                    productsWithoutDetach.length ? (
                      <>
                        <Typography>
                          Financeiro da Venda desativado devido a alterações nos
                          itens do pedido de venda. Para reativar, clique em
                          voltar e selecione todos os itens novamente.
                        </Typography>
                      </>
                    ) : (
                      ""
                    )
                  }
                  placement="top"
                >
                  <Grid item sm={4}>
                    <Card
                      style={{
                        opacity:
                          selectedItensDemand.length <
                          productsWithoutDetach.length
                            ? 0.4
                            : 1,
                      }}
                    >
                      <CardFinancial>
                        <MonetizationOn />
                      </CardFinancial>
                      <CardActionArea
                        disabled={
                          selectedItensDemand.length <
                          productsWithoutDetach.length
                        }
                      >
                        <CardContent
                          onClick={() => {
                            verifyFinancialIssue(false);
                          }}
                        >
                          <Typography gutterBottom variant="h5" component="h2">
                            Manter Financeiro Da Venda
                          </Typography>
                          <Typography
                            variant="body2"
                            color="textSecondary"
                            component="p"
                          >
                            O Contas a Receber se manterá de acordo com as
                            informações já existentes no Pedido.
                          </Typography>
                        </CardContent>
                      </CardActionArea>
                    </Card>
                  </Grid>
                </Tooltip>
              </Grid>
            </Grid>
          </WizardFinancial>
        );
      default:
        break;
    }
  }

  // Retorna a barra de informações (á cima dos
  // botões de 'voltar' e 'próximo') dos passos
  // na montagem automática padrão.
  function getStepContentStandard(step) {
    return (
      <Body>
        {getStepTableStandard(step)}
        <WizardFooter>
          <Grid container spacing={1} alignItems="center">
            <Grid item sm justifyContent="center" container>
              <ListItem>
                <ListItemAvatar>
                  <Avatar>
                    <AccountCircle />
                  </Avatar>
                </ListItemAvatar>
                <ListItemText
                  primary="Cliente Selecionado: "
                  secondary={
                    selectedReceiver[0] ? selectedReceiver[0].apelido : ""
                  }
                />
              </ListItem>
            </Grid>
            {step !== 0 && (
              <Grid item sm justifyContent="center" container>
                <ListItem>
                  <ListItemAvatar>
                    <Avatar>
                      <MonetizationOn />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText
                    primary="Pedido(s) Selecionado(s): "
                    secondary={
                      selectedDemands.length > 0
                        ? selectedDemands.map((value, index) => {
                            if (index === selectedDemands.length - 1) {
                              return value.numvenda;
                            } else {
                              return value.numvenda + ",";
                            }
                          })
                        : ""
                    }
                  />
                </ListItem>
              </Grid>
            )}
            {step > 1 && (
              <>
                <Grid item sm justifyContent="center" container>
                  <ListItem>
                    <ListItemAvatar>
                      <Avatar>
                        <ListAlt />
                      </Avatar>
                    </ListItemAvatar>
                    <ListItemText
                      primary="Total de Itens: "
                      secondary={selectedItensDemand.length}
                    />
                  </ListItem>
                </Grid>
                <Grid item sm justifyContent="center" container>
                  <ListItem>
                    <ListItemAvatar>
                      <Avatar>
                        <ListAlt />
                      </Avatar>
                    </ListItemAvatar>
                    <ListItemText
                      primary="Total de Itens R$: "
                      secondary={calcTotalItens("vlr_total")}
                    />
                  </ListItem>
                </Grid>
                <Grid item sm justifyContent="center" container>
                  <ListItem>
                    <ListItemAvatar>
                      <Avatar>
                        <ListAlt />
                      </Avatar>
                    </ListItemAvatar>
                    <ListItemText
                      primary="Total Liquido R$: "
                      secondary={calcTotalItens("vlr_total_liquido")}
                    />
                  </ListItem>
                </Grid>
              </>
            )}
          </Grid>
        </WizardFooter>
      </Body>
    );
  }

  function getStepTableDI(step) {
    switch (step) {
      case 0:
        return (
          <>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <TextField
                  label="Busque Por Qualquer Coluna Presente na Tabela"
                  value={filterDi}
                  setValue={setFilterDi}
                  variant="filled"
                  disabled={finalConsumer && activeStep === 0}
                />
              </Grid>
              <Grid item xs={6}>
                <FormControlLabel
                  label={`Mostrar DI já utilizadas`}
                  value="end"
                  control={
                    <Switch
                      checked={getUsedDi}
                      onChange={() => {
                        setGetUsedDi((current) => !current);
                      }}
                      color="primary"
                    />
                  }
                />
              </Grid>
            </Grid>
            <BigDataTable
              stickyHeader
              route="nf/declaracaoimportacao/v1/filtroParaVenda"
              rawUrl={`onlyOpenedDi=${getUsedDi ? "N" : "S"}&id_empresa=${
                queryParams.empresa_id
              }${filterDi ? queryOrWhereDi : ""}`}
              columns={columnsDITable}
              maxHeight="50vh"
              selectable={true}
              multiSelect={false}
              selected={selectedDI}
              setSelected={setSelectedDI}
            />
          </>
        );

      case 1:
        return (
          <>
            <TableDefault
              stickyHeader
              columns={columnsAdditions}
              values={selectedDI[0]?.diadicao.map((item) => ({
                ...item,
                cfop: selectedDI[0].dicontrole?.cfop?.cfop || "-",
              }))}
              selectable={true}
              multiSelect={true}
              selected={selectedAdditions}
              setSelected={setSelectedAdditions}
              maxHeight="50vh"
              rowId="numero"
              pageProp={pageProp}
              setPageProp={setPageProp}
            />
          </>
        );

      default:
        console.error("Passo não encontrado");
    }
  }

  function getStepContentDI(step) {
    return (
      <Body>
        {getStepTableDI(step)}
        <WizardFooter>
          <Grid container spacing={1} alignItems="center">
            <Grid item sm justifyContent="center" container>
              <ListItem>
                <ListItemAvatar>
                  <Avatar>
                    <FlightLand />
                  </Avatar>
                </ListItemAvatar>
                <ListItemText
                  primary="DI Selecionada: "
                  secondary={selectedDI[0] ? selectedDI[0].numerodi : "-"}
                />
              </ListItem>
              {step > 0 && (
                <ListItem>
                  <ListItemAvatar>
                    <Avatar>
                      <Queue />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText
                    primary="Adições selecionadas: "
                    secondary={
                      selectedAdditions.length
                        ? selectedAdditions.map((addition, i) =>
                            i + 1 === selectedAdditions.length
                              ? addition.numero
                              : `${addition.numero}, `
                          )
                        : "-"
                    }
                  />
                </ListItem>
              )}
            </Grid>
          </Grid>
        </WizardFooter>
      </Body>
    );
  }
};

export default WizardEmissaoVenda;
